export default __webpack_public_path__ + "static/media/product-2.fb642d4a.png";